<template>
  <div class="party-arch">
    <h3 class="party-arch__title">{{ architecture.title }}</h3>
    <div class="party-arch__body">
      <aside class="party-arch__sidebar party-arch__sidebar--left">
        <h4>服务对象</h4>
        <ul>
          <li v-for="item in architecture.serviceObjects" :key="item">{{ item }}</li>
        </ul>
      </aside>

      <div class="party-arch__center">
        <div
          v-for="layer in architecture.layers"
          :key="layer.name"
          class="party-arch__layer"
        >
          <div class="party-arch__layer-label">{{ layer.name }}</div>
          <div class="party-arch__layer-content">
            <h5 v-if="layer.sectionTitle" class="party-arch__section-title">{{ layer.sectionTitle }}</h5>

            <div v-if="layer.groups" class="party-arch__app-grid">
              <div
                v-for="group in layer.groups"
                :key="group.title"
                class="party-arch__app-module"
              >
                <h6>{{ group.title }}</h6>
                <div class="party-arch__module-items">
                  <span v-for="item in group.items" :key="item">{{ item }}</span>
                </div>
              </div>
            </div>

            <div v-else class="party-arch__items">
              <span v-for="item in layer.items" :key="item" class="party-arch__item">{{ item }}</span>
              <span v-if="layer.extra" class="party-arch__item party-arch__item--extra">{{ layer.extra }}</span>
            </div>
          </div>
        </div>
      </div>

      <aside class="party-arch__sidebar party-arch__sidebar--right">
        <h4>应用终端</h4>
        <ul>
          <li v-for="item in architecture.terminals" :key="item">{{ item }}</li>
        </ul>
      </aside>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PartyArchDiagram',
  props: {
    architecture: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.party-arch {
  max-width: 1200px;
  margin: 0 auto;
  border: 1px solid #f0c0c8;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
}

.party-arch__title {
  margin: 0;
  padding: 18px 24px;
  font-size: 22px;
  font-weight: 700;
  color: #c8102e;
  text-align: center;
  border-bottom: 1px solid #f0c0c8;
}

.party-arch__body {
  display: grid;
  grid-template-columns: 120px 1fr 120px;
  min-height: 520px;
}

.party-arch__sidebar {
  padding: 20px 12px;
  text-align: center;
  background: #fff5f6;
}

.party-arch__sidebar--left {
  border-right: 1px solid #f0c0c8;
}

.party-arch__sidebar--right {
  border-left: 1px solid #f0c0c8;
}

.party-arch__sidebar h4 {
  margin: 0 0 16px;
  font-size: 14px;
  font-weight: 700;
  color: #c8102e;
  writing-mode: vertical-rl;
  text-orientation: mixed;
  letter-spacing: 4px;
  display: inline-block;
  padding-bottom: 8px;
  border-bottom: 2px solid #c8102e;
}

.party-arch__sidebar ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.party-arch__sidebar li {
  font-size: 13px;
  font-weight: 600;
  color: #444;
  padding: 10px 6px;
  background: #fff;
  border: 1px solid #f0c0c8;
  border-radius: 4px;
  line-height: 1.4;
}

.party-arch__center {
  display: flex;
  flex-direction: column;
}

.party-arch__layer {
  display: flex;
  border-bottom: 1px solid #f0c0c8;
  flex: 1;
}

.party-arch__layer:last-child {
  border-bottom: none;
}

.party-arch__layer-label {
  flex: 0 0 44px;
  writing-mode: vertical-rl;
  text-orientation: mixed;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #c8102e;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 4px;
  border-right: 1px solid #a00d24;
}

.party-arch__layer-content {
  flex: 1;
  padding: 14px 16px;
  background: #fffafa;
  min-width: 0;
}

.party-arch__section-title {
  margin: 0 0 12px;
  font-size: 15px;
  font-weight: 700;
  color: #c8102e;
  text-align: center;
  padding: 6px 12px;
  background: #fde8ec;
  border-radius: 4px;
}

.party-arch__items {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
}

.party-arch__item {
  background: #fff;
  border: 1px solid #f0c0c8;
  color: #c8102e;
  font-size: 12px;
  font-weight: 600;
  padding: 8px 12px;
  border-radius: 3px;
  line-height: 1.35;
  text-align: center;
}

.party-arch__item--extra {
  background: #fde8ec;
  border-style: dashed;
}

.party-arch__app-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
}

.party-arch__app-module {
  background: #fff;
  border: 1px solid #f0c0c8;
  border-radius: 4px;
  padding: 10px 8px;
  min-height: 100%;
}

.party-arch__app-module h6 {
  margin: 0 0 8px;
  font-size: 13px;
  font-weight: 700;
  color: #fff;
  text-align: center;
  padding: 6px 4px;
  background: #c8102e;
  border-radius: 3px;
  line-height: 1.3;
}

.party-arch__module-items {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.party-arch__module-items span {
  font-size: 11px;
  color: #555;
  line-height: 1.4;
  padding: 3px 0;
  border-bottom: 1px dashed #f5e0e4;
  text-align: center;
}

.party-arch__module-items span:last-child {
  border-bottom: none;
}

@media (max-width: 960px) {
  .party-arch__body {
    grid-template-columns: 1fr;
  }

  .party-arch__sidebar {
    border-right: none !important;
    border-left: none !important;
    border-bottom: 1px solid #f0c0c8;
  }

  .party-arch__sidebar h4 {
    writing-mode: horizontal-tb;
    letter-spacing: 2px;
  }

  .party-arch__sidebar ul {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }

  .party-arch__sidebar li {
    flex: 1 1 calc(50% - 8px);
    min-width: 100px;
  }

  .party-arch__app-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 560px) {
  .party-arch__app-grid {
    grid-template-columns: 1fr;
  }

  .party-arch__sidebar li {
    flex: 1 1 100%;
  }
}
</style>
